<template>
  <div v-if="show" class="cookie-banner">
    <div class="container">
      <div class="cookie-notification">
        <div class="cookie-info">
          <p>
            {{ text }}
            <a v-if="showLearnMore" :href="learnMoreUrl" class="cookie-learn-more">{{
              learnMoreButtonText
            }}</a>
          </p>
        </div>
        <div class="cookie-close-block">
          <button v-if="showClose" class="cookie-close" @click="close()">x</button>
          <button class="cookie-submit-button" @click="close()">{{ buttonText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cookie-banner',
  props: {
    editMode: { type: Boolean, default: false },
    showLearnMore: { type: Boolean, default: false },
    showClose: { type: Boolean, default: false },
    text: { type: String, required: true },
    buttonText: { type: String, required: true },
    learnMoreUrl: { type: String, required: false },
    learnMoreButtonText: { type: String, required: false },
  },
  data() {
    return {
      show: !this.editMode,
    };
  },
  created() {
    this.getCookie('privacy-notification');
  },
  methods: {
    close() {
      this.createCookie('privacy-notification', 1, 365);
      this.show = false;

      /* istanbul ignore next */
      if (window.eventBus) {
        window.eventBus.$emit('headerHeight.updated', true);
        window.eventBus.$emit('cookie.gone', true);
      }
    },

    createCookie(name, value, days) {
      let expires;
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toGMTString()}`;
      } else {
        expires = '';
      }
      document.cookie = `${name}=${value}${expires}; path=/;Secure;SameSite=Strict;`;
    },
    getCookie(name) {
      const existcookie = document.cookie
        .split(';')
        .filter((item) => item.trim().startsWith(`${name}=`)).length;
      if (existcookie) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
  },
};
</script>
